<template>

    <form ref="avaliacaocargo-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="avaliacaoId">Cargo</label>
                <select v-select="{ dataitem: 'Cargo', default: 'Selecione' }" v-model="model.cargoId" class="form-control" name="cargoId" required></select>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "avaliacaocargo-form-create",
        props: { avaliacaoId: Number },
        mixins: [base],
        data: () => ({

            model: {},

            form: "avaliacaocargo-form-create",

            resources: {
                create: 'avaliacaocargo',
            },

        }),

        methods: {

            executeCreate: function (model) {

                model.avaliacaoId = this.avaliacaoId;

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

